import { render, staticRenderFns } from "./AsideRedes.vue?vue&type=template&id=b8a46378&scoped=true&"
import script from "./AsideRedes.vue?vue&type=script&lang=js&"
export * from "./AsideRedes.vue?vue&type=script&lang=js&"
import style0 from "./AsideRedes.vue?vue&type=style&index=0&id=b8a46378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a46378",
  null
  
)

export default component.exports